import React from 'react'

export default function Logo() {
	return (
		<div id='logo'>
			<img src="/images/logo.png" alt="AdScore by Unified" />
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/Logo.js